import { render, staticRenderFns } from "./AppInfoEvaluation.vue?vue&type=template&id=2653bb71&"
import script from "./AppInfoEvaluation.vue?vue&type=script&lang=js&"
export * from "./AppInfoEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports